import style from "./BudgetFilter.css";
import { useEffect, useContext, useRef } from "preact/hooks";
import { Tag } from "../Tag";
import {
  isMobileScreen,
  handleDropdownClose,
  handleDropdownOpen,
} from "../../helpers";

import { Context } from "../Context";
import { budgetEnds } from "../static-data";

const BudgetFilter = ({ budgetFilter, onBudgetSelect }) => {
  const [context, setContext] = useContext(Context);
  const node = useRef();

  // useEffect(() => {
  //   window.addEventListener("popstate", handlePop);
  //   return () => {
  //     document.removeEventListener("popstate", handlePop);
  //   };
  // }, []);

  // const handlePop = (event) => {
  //   if (window.location.search.indexOf("budgetOpen") >= 0) {
  //     setContext({ ...context, filterOpen: "budgetOpen" });
  //   } else {
  //     if (window.location.search.indexOf("budgetOpen") < 0) {
  //       setContext({ ...context, filterOpen: "" });
  //     }
  //   }
  // };

  const handleBudgetFilterOpen = () => {
    handleDropdownOpen("budgetOpen");
    setContext({ filterOpen: "budgetOpen" });
  };

  const handleBudgetFilterClose = () => {
    handleDropdownClose("budgetOpen");
    setContext({ filterOpen: "" });
  };

  const renderListItemStyle = (value) => {
    return value == budgetFilter ? style.selectedListItem : style.listItem;
  };

  const handleBudgetClick = (value) => {
    if (value === budgetFilter) {
      onBudgetSelect("");
    } else {
      onBudgetSelect(value);
    }
  };

  const conditionalMobileHeader = () => {
    if (!isMobileScreen()) return null;
    return (
      <div class={style.mobileBudgetHeader}>
        <div class={style.closeIcon} onClick={handleBudgetFilterClose}></div>
        <h4>Budget</h4>
        <div class={style.hidden}>x</div>
      </div>
    );
  };

  const checkDisabled = () => {
    if (!budgetFilter) return style.disableClear;
  };

  const getText = () => {
    if (budgetFilter && budgetFilter.toString().length > 0)
      return budgetFilter.toString() + " €";
    return "Budget";
  };

  const conditionalRenderDropdown = () => {
    if (context.filterOpen === "budgetOpen")
      return (
        <div
          class={style.budgetFilter}
          onClick={() => {
            if (!isMobileScreen()) {
              handleBudgetFilterClose();
            }
          }}
        >
          <div
            class={style.budgetFilterContainer}
            style={{
              left: node.current.base.getBoundingClientRect().left + "px",
              top: node.current.base.getBoundingClientRect().top + "px",
            }}
          >
            {conditionalMobileHeader()}
            <div class={style.budgetListContainer}>
              <ul class={style.budgetUl}>
                {budgetEnds.map((budget) => (
                  <li
                    key={budget.key}
                    class={renderListItemStyle(budget.value)}
                    onClick={() => {
                      handleBudgetClick(budget.value);
                      handleBudgetFilterClose();
                    }}
                  >
                    {budget.key}
                  </li>
                ))}
              </ul>
            </div>

            <div class={style.filterBoxBottom}>
              <span
                class={style.clearAllFilters + " " + checkDisabled()}
                onClick={() => {
                  onBudgetSelect("");
                  handleBudgetFilterClose();
                }}
              >
                Löschen
              </span>
              <button
                style={{ color: "white" }}
                onClick={handleBudgetFilterClose}
              >
                Speichern
              </button>
            </div>
          </div>
        </div>
      );
    return null;
  };

  return (
    <Fragment>
      <Tag
        ref={node}
        id="mapBudgetFilter"
        text={getText()}
        shouldTruncate={true}
        hasDropdown={true}
        selected={budgetFilter && budgetFilter.length !== 0}
        onClick={handleBudgetFilterOpen}
      />
      {conditionalRenderDropdown()}
    </Fragment>
  );
};

export { BudgetFilter };
